import {
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs,
} from '@ionic/react';

import { ShellMobileTabBar } from '@/core/components/navigation/mobile-bottom-nav';
import { ShellNavBridge } from '@/core/components/navigation/shell-nav-bridge';
import {
  getMoreTabStackRoot,
  shellTabRoutes,
  TAB_HOME,
  TAB_LEADS,
  TAB_MORE,
  TAB_PROFILES,
  TAB_ROOTS,
} from '@/core/router/app-routes';
import { shellUsesMobileTabBar } from '@/core/utils/shell-chrome';

/** Tab bar must stay in layout (not `display:none`) or Ionic tab stacks break on iOS. */
const HIDDEN_TAB_BAR_STYLE: { [key: string]: string } = {
  visibility: 'hidden',
  position: 'absolute',
  bottom: '0',
  left: '0',
  right: '0',
  height: '0',
  overflow: 'hidden',
  pointerEvents: 'none',
};

/**
 * iv-ac style: `IonTabs` → `IonRouterOutlet` + Cap floating bar (`slot="bottom"`)
 * or a hidden `IonTabBar` on browser for Ionic tab stacks.
 */
export function AppShellTabsOutlet() {
  const showMobileTabBar = shellUsesMobileTabBar();

  return (
    <div className="app-shell-tabs-host relative isolate flex min-h-0 flex-1 flex-col">
      <IonTabs>
        <ShellNavBridge />
        <IonRouterOutlet id="main-tabs">{shellTabRoutes()}</IonRouterOutlet>
        {showMobileTabBar ? (
          <ShellMobileTabBar />
        ) : (
          // Not permission-filtered on purpose: these buttons are invisible and
          // inert (see HIDDEN_TAB_BAR_STYLE) and exist only so Ionic can keep a
          // stack per tab. Dropping one breaks history for the whole outlet.
          // User-visible gating lives in the sidebar and `ShellMobileTabBar`.
          <IonTabBar slot="bottom" style={HIDDEN_TAB_BAR_STYLE}>
            <IonTabButton tab={TAB_HOME} href={TAB_ROOTS[TAB_HOME]}>
              <IonLabel />
            </IonTabButton>
            <IonTabButton tab={TAB_PROFILES} href={TAB_ROOTS[TAB_PROFILES]}>
              <IonLabel />
            </IonTabButton>
            <IonTabButton tab={TAB_LEADS} href={TAB_ROOTS[TAB_LEADS]}>
              <IonLabel />
            </IonTabButton>
            <IonTabButton tab={TAB_MORE} href={getMoreTabStackRoot()}>
              <IonLabel />
            </IonTabButton>
          </IonTabBar>
        )}
      </IonTabs>
    </div>
  );
}
